import type { ServiceQueryOptionType } from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { SlideshowItemDataType } from './types'

const QUERY_KEY = ['cms', 'slideshow'] as const

const getAll = (): ServiceQueryOptionType<SlideshowItemDataType[]> => ({
  queryKey: QUERY_KEY,
  retry: 3,
  queryFn: async () => {
    try {
      const response = await api.get<{
        message: string
        data: SlideshowItemDataType[]
        meta: {
          current_page: number
          last_page: number
          per_page: number
          total_data: number
        }
      }>('/cms/slideshow', { timeout: 30_000 })
      return response.data.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const slideshow = {
  getAll,
  QUERY_KEY
}
